import { Component, OnInit } from '@angular/core';
import {
	Data, Subscription, DataLoaderService, ResetService, CommonDataService, SummaryService,
	PriceCalculationService, AlternateOptionsService, ProgressBarService, SortingService,
} from '../service-call-index';
import { ExpertValidation } from '../../expert-screen-components/expert-validation/expert-validation.component';
import { SummaryValidationComponent } from './../summary-validations/summary-validations.component';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component';
import { Utils } from '../../../../shared/utils';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';
@Component({
	selector: 'factory-options',
	templateUrl: './factory-options.template.html',
	styleUrls: ['./factory-options.component.css'],
})
export class FactoryOptions implements OnInit {
	public factoryOptions: Data[];
	public lengthOfFactoryOptions: number;
	public selectedFacOptions: Data[] = [];
	public flag: boolean = false;
	public toggleContViewFactory: boolean = false;
	public factoryOptionsSuggList = [];
	public currency: string;
	private subscription: Subscription;
	public errMessage;
	public icon: string = "gray";
	public vehicleInfo: any;

	constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService,
		private resetService: ResetService, private alternateOptionsService: AlternateOptionsService,
		private summaryService: SummaryService, private priceCalculationService: PriceCalculationService,
		private progressService: ProgressBarService, private sortingService: SortingService,
		private alternateScreenComponent: AlternateScreenComponent, private vehicleInfoService: VehicleInfoService, private expertValidation: ExpertValidation,
		private summaryValidationComponent: SummaryValidationComponent) {
		this.vehicleInfo = this.vehicleInfoService.extractData();
		this.currency = this.dataLoaderService.data.currencyType;
		this.factoryOptions = this.dataLoaderService.data.facOptions;
	}
	/**
	 * Factory Options are loaded on initialisation
	 * @param none
	 * @returns none
	 */
	private temp: Data[] = [];
	private tempFlag: boolean = false;
	ngOnInit() {
		this.summaryService.getSelectedOptions();

		if (this.commonDataService.factoryFlag) {
			this.toggleContViewFactory = true;
		}

		//retention service
		this.subscription = this.priceCalculationService.notifyObservableExpertComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertFactory") {
				this.selectedFacOptions = [];
				for (let i in selectedOption.data[0]) {
					for (let j in this.factoryOptions) {
						if (this.factoryOptions[j].code === selectedOption.data[0][i].code) {
							this.factoryOptions[j].selected = true;
							this.selectedFacOptions.unshift(selectedOption.data[0][i]);
						}
					}
				}
			}
		});

		//fetching length for displaying in HTML
		this.lengthOfFactoryOptions = this.dataLoaderService.data.facOptions.length;

		//on load
		this.factoryOptions.forEach(element => {
			if (element.selected === true) {
				this.selectedFacOptions.unshift(element);
				// this.priceCalculationService.normalModePriceCalculation();
			}
		});

	}

	/**
	 * To select a factory option and populating the selected option in an array 
	 * @param item of Data type
	 * @returns none
	 */
	selectFactoryOption(item) {
			setTimeout(() => {
				this.progressService.illuminateRed();
			}, 0);
		
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.dataLoaderService.flagDictionary.resetFactoryFlag = false;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;

		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.factoryOptionsSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.factoryOptionsSuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
					else {
						for (let i in this.factoryOptions) {
							if (this.factoryOptions[i].code === item.code) {
								this.factoryOptions[i].selected = true;
								//Updated prices from validation response
								this.alternateScreenComponent.updatedPrices();
							}
						}
						
						this.flag = this.itemCheck(item);
						if (this.flag) {
							this.selectedFacOptions.unshift(item);
						}
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						if(this.dataLoaderService.flagDictionary.alternateValidateFlag === false){
							if(this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true){
								setTimeout(() => {
								this.progressService.illuminateGreen();								
								}, 0);
							}						
						}
						if(this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true){
							setTimeout(() => {
								this.progressService.illuminateGreen();
							}, 0);
						}
						this.saveFactory();
					}
					this.sortingService.sortCodes(this.factoryOptions, true)
				},
				err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {
			for (let i in this.factoryOptions) {
				if (this.factoryOptions[i].code === item.code) {
					this.factoryOptions[i].selected = true;
				}
			}
			this.flag = this.itemCheck(item);
			if (this.flag) {
				this.dataLoaderService.flagDictionary.validated = false;
				this.selectedFacOptions.unshift(item);
			}
			this.dataLoaderService.flagDictionary.validated = false;
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.factoryOptions, true)
			this.saveFactory();
			
		}

		this.progressService.progressBarValidation();
	}
	/**
	 * To uncheck the factory option selected and splice it from the array 
	 * @param item of Data type
	 * @returns boolean value
	 */
	itemCheck(item): boolean {
		let index: number = -1;
		for (let j in this.factoryOptions) {
			for (let i in this.selectedFacOptions) {
				if ((item.code === this.selectedFacOptions[i].code) && (item.code === this.factoryOptions[j].code)) {
					this.factoryOptions[j].selected = false;
					for (let s in this.dataLoaderService.gccUpdatedPrices) {
						for(let k in this.factoryOptions){
							if (this.factoryOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code && this.factoryOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType) {
								this.factoryOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
							}
						}
					}
					this.flag = false;
					this.selectedFacOptions.splice(Number(i), 1);
					return this.flag;
				}
			}
			this.flag = true;
		}
		return this.flag;
	}
	/**
	 * To go to the next Tab: Local Options tab when clicked on the Continue button
	 * @param none
	 * @returns none
	 */
	gotoNextTab() {
		if(this.isMarketCA_N()||this.isMarketCA_T()){
			this.commonDataService.notifyOther({ option: 'activeRim' });
		}
		else if(this.isMarketEG()){
			if(this.checkForEGLocalOptions()){
				if(this.checkForEGPkgOptions()){
					//  this.lastComponent = true;
				}
			} 
			else {
				this.commonDataService.notifyOther({ option: 'activePackage' });
			}
		}
		else{
			this.dataLoaderService.flagDictionary.modeFlag = 'normal';
			if (!this.dataLoaderService.flagDictionary.noLocalOptions) {
				this.commonDataService.notifyOther({ option: 'activeLocal' });
			}
			else if (!this.dataLoaderService.flagDictionary.noPackagesOptions) {
				this.commonDataService.notifyOther({ option: 'activePackage' });
			}
		}
	}
	/**
	 * To send the selected factory option to the Summary screen and calculate the price accordingly
	 * @param none
	 * @returns none
	 */
	saveFactory() {

		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.selectedFacOptions] });
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.selectedFacOptions] });

		this.priceCalculationService.normalModePriceCalculation();
	}

	openAlternateScreen() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
			this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
			this.progressService.illuminateRed();
			}

	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.progressService.illuminateRed();
	
	}
	validate() {
		this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();
	}
	isMarketCA_N(){
		return Utils.isCountryCA_N(this.vehicleInfo.orderingMarket);
	}
	
	isMarketCA_T(){
		return Utils.isCountryCA_T(this.vehicleInfo.orderingMarket);
	}
	isMarketMX(){
		return Utils.isCountryMX(this.vehicleInfo.orderingMarket);
	}
	isMarketEG(){
		return Utils.isCountryMX(this.vehicleInfo.orderingMarket);
	}
	checkForEGLocalOptions(){
		if(this.isMarketEG()){
			if(this.dataLoaderService.data.options.length>0){
				return false;
			}
			else{
				return true;
			}
		}
	}
	checkForEGPkgOptions(){
		if(this.isMarketEG()){
			if((this.dataLoaderService.data.localPackagesList.length>0)&&(this.dataLoaderService.data.packages.length>0)){
				return false;
			}
			else{
				return true;
			}
		}
	}	
}






// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/factory-options/factory-options.component.ts